import React, { createContext, useContext, useEffect, useReducer } from 'react'
import { TAppProps, TAppState, TNotificationContext } from './types'
import { notificationReducer } from './reducer'

import { FILTER_TYPE } from './action'
import { translations, TTranslationKey } from '../translations'
import useFirebase from '../hooks/useFirebase'
import { ELanguage } from '../../Utils/constants'

export const initialStore: Required<TAppState> = {
    isOpen: false,
    isLoading: true,
    notifications: [],
    jobInvitationNotifications: [],
    notificationCount: 0,
    notificationBellCount: 0,
    filter: FILTER_TYPE.ALL
}

const Context = createContext<TNotificationContext>({
    state: initialStore,
    props: {
        langCode: ELanguage.VI,
        config: null,
        user: null
    },
    firebase: {
        getNotification: async () => {},
        setReadNotificationItem: async () => {}
    },
    t: (_: string) => '',
    dispatch: () => {}
})

export type TNotificationProviderProps = TAppProps & {
    children: React.ReactNode
}

export const useNotifyStore = () => useContext(Context)

const NotificationProvider = (props: TNotificationProviderProps) => {
    const [state, dispatch] = useReducer(notificationReducer, initialStore)
    const { getNotification, setReadNotificationItem, doAuthenticate } = useFirebase({
        state,
        dispatch,
        props
    })

    const t = (text: TTranslationKey) => {
        if (props.langCode === ELanguage.VI) {
            return translations[text] ?? text
        }
        return text
    }

    useEffect(() => {
        if (!props.user || (props.user && props.user?.accessToken === '')) {
            return
        }
        // Re-authenticate again after user logged-in
        doAuthenticate()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.user])

    const firebase = {
        getNotification,
        setReadNotificationItem
    }

    return <Context.Provider value={{ state, props, firebase, t, dispatch }}>{props.children}</Context.Provider>
}

export default NotificationProvider
